<div class="bp-badge {{ variant }} {{ size }}">
	<ng-content></ng-content>
</div>
